/* eslint-disable
    func-names,
    guard-for-in,
    no-cond-assign,
    no-param-reassign,
    no-restricted-syntax,
    no-unused-vars,
    no-useless-escape,
    no-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('../service/apolloService');

const deps = ['MainApi', '$q', 'Store', '_', 'ViewModel', 'apolloService'];

const factory = function (MainApi, $q, Store, _, ViewModel, apolloService) {
  class Model extends Store {
    static initClass() {
      this.prototype.$graphqlClient = apolloService;

      this.prototype.$resource = '';

      this.prototype.$idName = 'id';

      this.prototype.$resolved = true; // convenience boolean for state of all current API calls

      this.prototype.$promise = $q.when(); // convenience promise for all current API calls

      this.prototype.$apiService = MainApi;

      this.prototype.$viewModelType = ViewModel;

      /**
       * Validations
       */

      this.prototype.$validators = {};
      // # e.g.
      // name:
      //   nonEmpty: (attr) ->
      //     # return boolean
      //     attr.length isnt 0
      // # Describe the model behaviour
      // this:
      //   openBeforeClose: (model) ->
      //     model.openingDate < model.closingDate

      this.prototype.$modelValidators = {};
      // # e.g.
      // openBeforeClose: (data) ->
      //   openingDate = data.attributes.openingDate
      //   closingDate = data.attributes.closingDate

      //   if openingDate and closingDate
      //     return Date.parse(openingDate) <= Date.parse(closingDate)
      //   else
      //     return true

      // This could be changes to explicitly define which parameters are being tested,
      // and then inject them into the test function in a similar manner to Angular's
      // dependancy injection.

      // # e.g.
      // $modelValidators
      //   openBeforeClose:
      //     test: (open, close) -> open < close
      //     attrs: ['attributes.open', 'attributes.close']

      // $validateModel = (data) ->
      //   errors = {}

      //   for key, validation of @$modelValidators
      //     args = _.map(validation.attrs, (attr) -> $parse(attr)(data))

      //     if not validation.test args...
      //       errors[key] = modelErrorMessages[key] or "#{@$resource} validation \"#{key}\" failed"

      //   return errors

      this.prototype.$errorMessages = {};
      // # e.g.
      // vendor:
      //   nonEmpty: "Vendor name can't be blank"

      this.prototype.$errors = {};
    }

    $cacheId() {
      return `${this.$className()}-model-${this.$storeId()}`;
    }

    $url(id) {
      if (id == null) {
        id = '';
      }
      return `${this.$resource}.json/${id}`;
    }

    $getUrl(id) {
      return (typeof this.$url === 'function' ? this.$url(id) : undefined) || this.$url || '';
    }

    $postUrl(id = '') {
      return this.$getUrl(id);
    }

    // api client that updates the $resolved variable
    $apiCall(options, api) {
      api = api || this.$apiService;

      this.$resolved = false;

      options.headers = options.headers || {};

      if (this.$etag) {
        options.headers = { ...options.headers, 'If-Match': this.$etag };
      }

      const apiCallPromise = api.request(options);

      const newPromise = $q.all([this.$promise, apiCallPromise]);

      this.$promise = newPromise;

      newPromise.then(resArray => {
        const res = resArray[resArray.length - 1];
        // if no new calls have been made
        this.$etag = res.headers('etag');

        if (this.$promise === newPromise) {
          this.$resolved = true;
        }
        return res;
      });

      return apiCallPromise;
    }

    $isNew() {
      return this.$storeId() == null;
    }

    $init() {
      this.$resolved = true;

      // test for model instantiated without an id
      if (this.$storeId() != null && this.$lastUpdated === 0) {
        return this.$fetch();
      }
    }

    $validateAttr(attrName, data) {
      const errors = {};
      const attrValidators = this.$validators[attrName] || {};
      const errorMessages = this.$errorMessages[attrName] || {};

      for (const key in attrValidators) {
        const validation = attrValidators[key];
        if (!validation(data[attrName])) {
          errors[key] =
            errorMessages[key] || `${this.$resource}.${attrName} validation \"${key}\" failed`;
        }
      }

      return errors;
    }

    $validateModel(data) {
      const errors = {};
      const modelValidators = this.$modelValidators || {};
      const errorMessages = this.$errorMessages.model || {};

      for (const key in modelValidators) {
        const validator = modelValidators[key];
        if (!validator(data)) {
          errors[key] = errorMessages[key] || `${this.$resource} validation \"${key}\" failed`;
        }
      }

      return errors;
    }

    $validate(data) {
      let modelErrors;
      data = data || this.$data();

      this.$errors = {};

      for (const attr in data) {
        let errors;
        if (!_.isEmpty((errors = this.$validateAttr(attr, data)))) {
          this.$errors[attr] = this.$validateAttr(attr, data);
        }
      }

      if (!_.isEmpty((modelErrors = this.$validateModel(data)))) {
        this.$errors.model = modelErrors;
      }

      return this.$errors;
    }

    /**
     * Standard REST functions
     */
    $fetch(params = {}, shouldSet = true) {
      const url = this.$getUrl(this.$storeId());
      return this.$apiCall({
        method: 'GET',
        url,
        params,
      }).then(res => {
        if (res.data != null && shouldSet) {
          this.$set(this.$serialize(res.data));
        }
        return res;
      });
    }

    $put(data, params = {}, opts = { fetch: true, shouldUpdate: true }) {
      return this.$apiCall({
        method: 'PUT',
        url: this.$getUrl(this.$storeId()),
        data: this.$deserialize(data || this.$data()),
        params,
      }).then(res => {
        if (opts.fetch) {
          this.$fetch();
        } else if (opts.shouldUpdate) {
          this.$set(this.$serialize(res.data || res));
        }
        return res;
      });
    }

    $delete(params = {}) {
      return this.$apiCall({
        method: 'DELETE',
        url: this.$getUrl(this.$storeId()),
        params,
      }).then(() => this.$destroy());
    }

    $post(data) {
      if (!_.isEmpty(this.$validate(data))) {
        return $q.reject(this.$errors);
      }

      return this.$apiCall({
        method: 'POST',
        url: this.$postUrl(),
        data: this.$deserialize(data),
      }).then(res => new this.constructor(res.data));
    }

    $createOrUpdate(data, params) {
      if (this.$storeId()) {
        return this.$put(data, params);
      }
      return this.$post(data);
    }

    // called to serialize data from the server to the model
    // ie. server returns timestamp, but you want a date object
    // used in $fetch
    $serialize(data) {
      return data;
    }

    // called to prepare data from the model for server consumption
    // used in $put and $post
    $deserialize(data) {
      return data;
    }

    $toJson() {
      return angular.toJson(this.$deserialize(this.$data()));
    }

    // create view model for this model
    // `name` is an optional parameter which allows you to
    // fetch/create a viewModel from cache
    $viewModel(name) {
      const vm = new this.$viewModelType(name);
      vm.$setModel(this);
      return vm;
    }
  }
  Model.initClass();

  return Model;
};

factory.$inject = deps;

module.exports = factory;
